import {useEffect, useState} from 'react'
import Modal from '../Modal/Modal'
import {useModal} from 'src/hooks/useModal'
import {useResetRecoilState} from "recoil";
import {SecurityNumState, TimeOutState, TranIdState} from "src/store/recoil/common";

const Timer = (props: any) => {
    const {time} = props
    const {isOpen, toggle} = useModal()
    const [minutes, setMinutes] = useState(time / 60)
    const [seconds, setSeconds] = useState(time % 60)
    const ResetTimeOut = useResetRecoilState(TimeOutState)
    const ResetTranId = useResetRecoilState(TranIdState)
    const ResetSecurityNum = useResetRecoilState(SecurityNumState)
    useEffect(() => {
        const countdown = setInterval(() => {
            if (Number(seconds) > 0) {
                setSeconds(Number(seconds) - 1)
            }
            if (Number(seconds) === 0) {
                if (Number(minutes) === 0) {
                    clearInterval(countdown)
                } else {
                    setMinutes(Number(minutes) - 1)
                    setSeconds(59)
                }
            }
        }, 1000)
        return () => clearInterval(countdown)
    }, [ResetTimeOut, minutes, seconds])

    useEffect(() => {
        if (minutes === 0 && seconds === 1) {
            setTimeout(async () => {
                toggle()
            }, 1000)
        }
    }, [minutes, seconds, toggle])
    return (
        <>
            <span>0{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</span>
            <Modal
                isOpen={isOpen}
                type='alert'
                toggle={toggle}
                setOption={211}
                ClickFunc={() => {
                    toggle()
                    ResetTimeOut()
                    ResetSecurityNum()
                    ResetTranId()
                    document.body.style.overflow = 'unset'
                }}
            />
        </>
    )
}

export default Timer
